import React from 'react';
import PropTypes from 'prop-types';

const GenericButton = ({
  name,
  btnStyle,
  onBtnClick,
  onBlur,
  btnDisabled,
  title,
}) => (
  <button
    type="button"
    className={btnStyle}
    onClick={onBtnClick}
    onBlur={onBlur}
    disabled={btnDisabled}
    title={title}
  >
    {name}
  </button>
);

GenericButton.propTypes = {
  name: PropTypes.string.isRequired,
  onBtnClick: PropTypes.func,
  onBlur: PropTypes.func,
  btnDisabled: PropTypes.bool,
  btnStyle: PropTypes.string,
  title: PropTypes.string,
};

GenericButton.defaultProps = {
  btnStyle: 'button',
  title: '',
  onBtnClick: () => console.warn('Generic Btn Handler is not provided'),
};

export default GenericButton;
